import {
    GET_PROVISION_STATUS_DEF,
    GET_PROVISION_STATUS_DEF_SUCCESS,
    PROVISION_STATUS_DEF_API_ERROR
} from "./actionTypes"

export const getProvisionStatusDefList = () => ({
    type: GET_PROVISION_STATUS_DEF,
})

export const getProvisionStatusDefListSuccess = record => ({
    type: GET_PROVISION_STATUS_DEF_SUCCESS,
    payload: record,
})

export const provisionStatusDefApiError = error => {
    return {
        type: PROVISION_STATUS_DEF_API_ERROR,
        payload: error,
    }
}